






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

interface PenurunanOption { value: string; label: string; skor: number; }

@Component
export default class MstSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    penurunan_bb: "tidak",
    penurunan_bb_skor: 0,
    nafsu_makan_berkurang: "tidak",
    nafsu_makan_skor: 0,
    total_skor: 0,
    perlu_konsul_gizi: false
  };

  penurunanOptions: PenurunanOption[] = [
    { value: "tidak", label: "Tidak", skor: 0 },
    { value: "tidak_yakin", label: "Tidak yakin (baju menjadi longgar)", skor: 2 },
    { value: "1_5", label: "Ya, 1–5 kg", skor: 1 },
    { value: "6_10", label: "Ya, 6–10 kg", skor: 2 },
    { value: "11_15", label: "Ya, 11–15 kg", skor: 3 },
    { value: "gt_15", label: "Ya, > 15 kg", skor: 4 },
    { value: "tidak_tahu", label: "Tidak tahu berapa kg", skor: 2 }
  ];

  @Watch("form.penurunan_bb")
  onPenurunan(val: string) {
    const opt = this.penurunanOptions.find(o => o.value === val);
    this.form.penurunan_bb_skor = opt ? opt.skor : 0;
    this.recalc();
  }

  @Watch("form.nafsu_makan_berkurang")
  onNafsu(val: string) {
    this.form.nafsu_makan_skor = val === "ya" ? 1 : 0;
    this.recalc();
  }

  recalc() {
    const total = Number(this.form.penurunan_bb_skor || 0) + Number(this.form.nafsu_makan_skor || 0);
    this.form.total_skor = total;
    this.form.perlu_konsul_gizi = total >= 2;
  }

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    this.onPenurunan(this.form.penurunan_bb);
    this.onNafsu(this.form.nafsu_makan_berkurang);
  }
}
